import React from "react";
import {
  BorderBox,
  RadioSectionContainer,
  RadioQuestion,
  RadioButtonsContainer,
  Error
} from "./style";
import RadioButtons, {
  RadioButtonWidthOptions
} from "@acko-tech/building-blocks.ui.radio-button";

interface Props {
  isCommercial: any;
  handleCommercialSubmit: Function;
}

const ExternalCngCommercial = (props: Props) => {
  const { isCommercial, handleCommercialSubmit } = props;
  const isCommercialVehicle = isCommercial?.displayValue === "Yes";

  return (
    <>
      <BorderBox isCommercialVehicle={isCommercialVehicle}>
        <RadioSectionContainer>
          <RadioQuestion>Is this a commercial vehicle?</RadioQuestion>
          <RadioButtonsContainer>
            <RadioButtons
              selectedValue={isCommercial}
              options={[
                { value: "1", displayValue: "Yes" },
                { value: "0", displayValue: "No" }
              ]}
              theme={{
                default: "",
                selected: "#0FA457",
                selectedText: "black"
              }}
              onSubmit={item => {
                handleCommercialSubmit(item);
              }}
              fontSize="xs"
              widthBwButtons={RadioButtonWidthOptions.xl}
            />
          </RadioButtonsContainer>
        </RadioSectionContainer>
        {isCommercialVehicle && (
          <Error>Sorry! We don't offer policies for commercial vehicle</Error>
        )}
      </BorderBox>
    </>
  );
};

export default ExternalCngCommercial;
